import { _ as __read } from '../../../../../_tslib-7a01aab4.js';
import React, { useState, useLayoutEffect } from 'react';
import { observer } from 'mobx-react-lite';
import '../../../../core/enums/GameSpecificTypes.js';
import '../../../../core/enums/MaxPayoutDataTypes.js';
import '../../../../core/enums/Chat.js';
import '../../../../core/enums/GameModes.js';
import '../../../../core/enums/IconTypes.js';
import '../../../../core/enums/BetStatus.js';
import '../../../../core/enums/PopupTypes.js';
import '../../../../core/enums/ApiVersion.js';
import { RoundStatus } from '../../../../core/enums/RoundStatus.js';
import '../../../../core/enums/FreeBetsStatus.js';
import '../../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../../core/enums/TranslationKeys.js';
import '../../../../core/enums/TimeoutMaxValue.js';
import '../../../../core/enums/ApiServiceTypes.js';
import '../../../../core/enums/EnvironmentTypes.js';
import '../../../../core/enums/DefaultQueryValues.js';
import '../../../../core/enums/FreeBetWinningType.js';
import '../../../../core/enums/DefaultQueryParams.js';
import '../../../../core/enums/BetHistoryFilterTypes.js';
import '../../../../core/enums/GameThemeTypes.js';
import '../../../../core/enums/RequestStatus.js';
import '../../../../core/enums/FetchDefaultPaths.js';
import '../../../../core/enums/ResponseCodes.js';
import { autoBetCountListConst } from '../../../../core/enums/BogLineGameConfig.js';
import { a2 as betDataStore, a1 as doBetStore } from '../../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../../core/store/chatStore.js';
import '../../../../core/store/wageringStore.js';
import '../../../../core/store/roundInfoStore.js';
import '../../../../core/store/userCountStore.js';
import '../../../../core/store/gameResultStore.js';
import '../../../../core/store/resultHashStore.js';
import '../../../../core/store/userWinBetsStore.js';
import '../../../../core/store/notificationStore.js';
import '../../../../core/store/selectedResultInfoStore.js';
import '../../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../../core/store/forCrashGame/totalBetStore.js';
import '../../../../core/store/forCrashGame/resultReportStore.js';
import { gameStore } from '../../../../core/store/forCrashGame/gameStore.js';
import { getAmountWithCurrency } from '../../../../core/helpers/getAmountWithCurrency.js';
import '../../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../../core/services/sound/types.js';
import '../../../../core/services/sound/SoundService.js';
import '../../../../core/services/sound/defaultSounds.js';
import '../../../../core/services/api/types.js';
import '../../../../core/services/ApiServices.js';
import '../../../../../momentFormat-e9197995.js';
import '../../../../core/polyfill.js';
import '../../../../contexts/TranslationContext.js';
import '../../../../contexts/StoreContext.js';
import { useTranslation } from '../../../../hooks/useTranslation.js';
import '../../../../core/enums/additionalInputValueChangingButtons.js';
import 'mobx';
import '../../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../../core/helpers/parseQuery.js';
import '../../../../core/enums/StatisticsSortingTypes.js';
import '../../../../core/services/api/BaseApiService.js';
import '../../../../core/helpers/deepCopy.js';
import '../../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../../core/helpers/formatDate.js';
import '../../../../core/helpers/isMobile.js';
import '../../../../core/enums/bogGameNames.js';
import '../../../../core/helpers/updateHalfBets.js';
import '../../../../core/enums/Currencies.js';
import 'howler';
import '../../../../../_commonjsHelpers-17aad09c.js';
import '../../../../core/helpers/setTranslationValues.js';

var AutoBetPopUp = observer(function (_a) {
    var sectionIndex = _a.sectionIndex, _b = _a.autoBetCountListArg, autoBetCountListArg = _b === void 0 ? null : _b;
    var t = useTranslation();
    var setIsAutoBet = betDataStore.setIsAutoBet, setAutoBetChosenCount = betDataStore.setAutoBetChosenCount, betsSectionsData = betDataStore.betsSectionsData, resetAutoBet = betDataStore.resetAutoBet, setIsAutoBetOpen = betDataStore.setIsAutoBetOpen;
    var doBetSender = doBetStore.doBetSender, doBetSectionsData = doBetStore.doBetSectionsData, handleBetForNextRound = doBetStore.handleBetForNextRound;
    var _c = __read(useState(null), 2), totalAmount = _c[0], setTotalAmount = _c[1];
    var _d = doBetSectionsData[sectionIndex], isBetAccepted = _d.isBetAccepted, isNextRoundBet = _d.isNextRoundBet;
    var _e = betsSectionsData[sectionIndex], autoBetCount = _e.autoBetCount, betAmount = _e.betAmount;
    var AutoBet = TranslationKeys.AutoBet, NumberOfRounds = TranslationKeys.NumberOfRounds, Total = TranslationKeys.Total, Play = TranslationKeys.Play;
    var currentGameState = gameStore.currentGameState;
    var autoBetCountList = autoBetCountListArg || autoBetCountListConst;
    var choseAutoBetCount = function (count, index) {
        setAutoBetChosenCount(count, index);
    };
    var sendAutoBet = function (index) {
        setIsAutoBet(true, index);
        setIsAutoBetOpen(false, index);
        if (isNextRoundBet) {
            handleBetForNextRound(index);
        }
        if (currentGameState === RoundStatus.Started && !isBetAccepted) {
            doBetSender(index);
        }
    };
    useLayoutEffect(function () {
        if (!autoBetCount) {
            // @ts-ignore
            choseAutoBetCount(autoBetCountList[0], sectionIndex);
            // @ts-ignore
            setTotalAmount(function () { return +betAmount * autoBetCountList[0]; });
        }
        else {
            setTotalAmount(function () { return +betAmount * autoBetCount; });
        }
    }, [autoBetCount, totalAmount]);
    return (React.createElement("div", { className: 'auto-bet-popup-wrapper' },
        React.createElement("div", { className: 'auto-bet-popup-holder' },
            React.createElement("div", { className: 'auto-bet-popup-title-block' },
                React.createElement("p", { className: 'auto-bet-popup-title' }, t(AutoBet)),
                React.createElement("div", { className: 'auto-bet-popup-close', onClick: function () { return resetAutoBet(+sectionIndex); } },
                    React.createElement("i", { className: 'ui-lib-close-x' }))),
            React.createElement("div", { className: 'auto-bet-popup-content' },
                React.createElement("p", { className: 'auto-bet-popup-content-number' }, " ".concat(t(NumberOfRounds), " : ").concat(autoBetCount)),
                React.createElement("p", { className: 'auto-bet-popup-content-total' }, "".concat(t(Total), " : ").concat(getAmountWithCurrency({
                    amount: (+totalAmount).toFixed(2),
                }), " ")),
                React.createElement("div", { className: 'auto-bet-popup-small-btn-wrp' }, autoBetCountList.map(function (count) { return (React.createElement("div", { key: count, className: "auto-bet-popup-small-btn ".concat(autoBetCount === count ? 'active' : '', " "), onClick: function () { return choseAutoBetCount(count, sectionIndex); } },
                    React.createElement("span", null, count))); }))),
            React.createElement("div", { className: 'auto-bet-popup-play' },
                React.createElement("button", { className: 'auto-bet-popup-button', onClick: function () { return sendAutoBet(sectionIndex); } },
                    React.createElement("i", { className: 'ui-lib-avi-play' }),
                    React.createElement("span", null, t(Play)))))));
});

export { AutoBetPopUp };
